import { useCallback, useEffect, useRef, useState } from "react";
import AutocompleteFetchInput from "../../../javascript/presentation/components/inputs/autocomplete-fetch-input";
import { getWorksListByFormId } from "../../../javascript/api/works";
import { toWorkOptions } from "../../../javascript/helpers/helpers";


const WorksFilterByFormID = ({ onChange, accountId, clearFilter, disabled, formIds = [], selectedIds = [] }) => {
    const [selectedWorkOptions, setSelectedWorkOptions] = useState(selectedIds.map((id) => ({ value: id, label: 'Carregando...' })));
    const initializedIds = useRef([]);
    const prevFormIdsRef = useRef(null);
    const isMountedRef = useRef(false);

    const handleWorksChange = (data) => {
        const newIds = data.map((work) => work.value);
        initializedIds.current = newIds;
        setSelectedWorkOptions(data);
        onChange(newIds);
    };

    useEffect(() => {
        if (clearFilter) {
            setSelectedWorkOptions([]);
            initializedIds.current = [];
        }
    }, [clearFilter]);

    useEffect(() => {
        if (!isMountedRef.current) {
            isMountedRef.current = true;
            prevFormIdsRef.current = formIds;
            return;
        }

        if (JSON.stringify(prevFormIdsRef.current) === JSON.stringify(formIds)) return;
        prevFormIdsRef.current = formIds;

        if (!formIds || formIds.length === 0) {
            setSelectedWorkOptions([]);
            return;
        }

        setSelectedWorkOptions((prev) => {
            const filtered = prev.filter((work) => formIds.includes(work.formId));
            if (filtered.length !== prev.length) {
                onChange(filtered.map((w) => w.value));
            }
            return filtered;
        });
    }, [formIds]);

    const fetchWorks = useCallback(async (q = "") => {
        try {
            if (!formIds.length) {
                setSelectedWorkOptions([]);
                onChange([]);
                return [];
            }

            const result = await getWorksListByFormId({ accountId, q, formIds });
            return toWorkOptions(result.results);
        } catch (err) {
            console.error(err);
            return [];
        }
    }, [formIds, accountId]);

    useEffect(() => {
        if (
            !selectedIds.length || JSON.stringify(initializedIds.current) === JSON.stringify(selectedIds)
        ) {
            return;
        }

        initializedIds.current = [...selectedIds];

        getWorksListByFormId({ accountId, formIds, ids: selectedIds })
            .then((result) => setSelectedWorkOptions(toWorkOptions(result.results)))
            .catch(console.error);
    }, [accountId, formIds, selectedIds]);

    return (
        <AutocompleteFetchInput
            label="Atividades"
            value={selectedWorkOptions}
            setValue={handleWorksChange}
            fetchOptions={fetchWorks}
            disabled={disabled}
        />
    );
};

export default WorksFilterByFormID;
